import { SuiNetworks } from '@packages/utils/enums'

export const suiPackages = {
  [SuiNetworks.DEVNET]: '0xd286ee42d5d11f0fdc4a872c6669b95d565fbcbd38cbfbc422998970bad2fe10',
  [SuiNetworks.TESTNET]: '0xba2fd0bf21cbd67224c1666019f2a33114edf9d7e29264be4cc179bb57323faa',
  [SuiNetworks.MAINNET]: '0xe64d96c0cbe4c37add416ae07fd6494722210c247bc2a4ba2e91542dc599c9fb',
}

export const suiAirdropPackages = {
  [SuiNetworks.DEVNET]: '0xd286ee42d5d11f0fdc4a872c6669b95d565fbcbd38cbfbc422998970bad2fe10',
  [SuiNetworks.TESTNET]: '0x2337ee16db47843d4bbf489cc9c2f155832fec5928ec1c21052e604184fbdeb2',
  [SuiNetworks.MAINNET]: '0x95a6d3b0ee9cb477dfd4ebec796094516ba28e325560609c0dd8c5076d2eae56',
}
